<div class="wk-navbar__breadcrumb" [class.clicked]="allApplications">
    <div class="wk-navbar__breadcrumb__items">
        <div class="wk-navbar__breadcrumb__item" (click)="toggleAppMenu(null, null, null, 'app')">
            <div class="wk-navbar__breadcrumb__item-content">
                @if (iconLabelKey(current?.flavor); as iconLabel) {
                    <span class="wk-navbar__breadcrumb__item-icon">{{ iconLabel | translate }}</span>
                }
                <div class="wk-navbar__breadcrumb__item-title">{{ current?.appTitle }}</div>
            </div>
            <div class="fa fa-fw fa-chevron-right"></div>
        </div>
        @if (!isJobsBillingDashboard && current?.year) {
            <div
                #wkNavbarBreadcrumbButtonYear
                class="wk-navbar__breadcrumb__item"
                (click)="toggleAppMenu(current.appTitle, current.flavor, null, 'year')"
            >
                <div class="wk-navbar__breadcrumb__item-title">{{ current?.year }}</div>
                <div class="fa fa-fw fa-chevron-right"></div>
            </div>
        }
        @if (current?.dashboard?.Title) {
            <div
                #wkNavbarBreadcrumbButtonDashboard
                class="wk-navbar__breadcrumb__item"
                (click)="toggleAppMenu(current.appTitle, current.flavor, current.year, 'dashboard')"
            >
                <div class="wk-navbar__breadcrumb__item-title">{{ current?.dashboard?.Title }}</div>
            </div>
        }
    </div>
    @if (allApplications) {
        <div class="wk-navbar__submenu" (click)="closeAllSubMenus()">
            <div
                class="wk-navbar__submenu__items wk-navbar__submenu__items--application"
                [class.wk-navbar__submenu__items--hidden]="breadcrumbVisibility_Years"
                [style.maxWidth.px]="submenuWidth_Application()"
                [style.width.%]="submenuWidth_Application() ? 100 : null"
            >
                @for (app of allApplications; track app.index) {
                    <div
                        class="wk-navbar__submenu__item"
                        [class.wk-navbar__submenu__item--current]="app.isCurrent"
                        [class.wk-navbar__submenu__item--selected]="selectedApp?.appTitle === app.appTitle && selectedApp?.flavor === app.flavor"
                        (click)="onAppSelected($event, app)"
                    >
                        <div class="wk-navbar__submenu__item-content">
                            @if (iconLabelKey(app.flavor); as iconLabel) {
                                <span class="wk-navbar__submenu__item-icon">{{ iconLabel | translate }}</span>
                            }
                            <div class="wk-navbar__submenu__item-title">{{ app.appTitle }}</div>
                        </div>
                        @if (selectedApp?.appTitle === app.appTitle && selectedApp?.flavor === app.flavor) {
                            <div class="fa fa-fw fa-chevron-right"></div>
                        }
                    </div>
                }
            </div>
            @if (appYears) {
                <div
                    #wkNavbarSubmenuItemsYear
                    class="wk-navbar__submenu__items wk-navbar__submenu__items--year"
                    [class.wk-navbar__submenu__items--hidden]="breadcrumbVisibility_DashboardNames"
                    [style.--itemsTop]="(!breadcrumbVisibility_Years && selectedApp?.index ? selectedApp.index : 0) * 40 + 'px'"
                    [style.maxWidth.px]="submenuWidth_Years()"
                    [style.width.%]="submenuWidth_Years() ? 100 : null"
                >
                    @for (year of appYears; track year.index) {
                        <div
                            class="wk-navbar__submenu__item"
                            [class.wk-navbar__submenu__item--current]="year.isCurrent"
                            [class.wk-navbar__submenu__item--selected]="selectedYear?.year === year.year"
                            (click)="onYearSelected($event, year)"
                        >
                            <div class="wk-navbar__submenu__item-title">{{ year.year }}</div>
                            @if (selectedYear?.year === year.year) {
                                <div class="fa fa-fw fa-chevron-right"></div>
                            }
                        </div>
                    }
                </div>
            }
            @if (appYearDashboards) {
                <div
                    class="wk-navbar__submenu__items wk-navbar__submenu__items--dashboard"
                    [style.--itemsTop]="
                        ((!breadcrumbVisibility_DashboardNames && selectedYear?.index ? selectedYear.index : 0) +
                            (!breadcrumbVisibility_Years && selectedApp?.index ? selectedApp.index : 0)) *
                            40 +
                        'px'
                    "
                >
                    @for (dashboard of appYearDashboards; track dashboard.Id) {
                        <div
                            class="wk-navbar__submenu__item"
                            [class.wk-navbar__submenu__item--current]="dashboard.isCurrent"
                            [routerLink]="[dashboard.Id, 'active']"
                            (click)="onDashboardSelected(dashboard?.Id)"
                        >
                            <div class="wk-navbar__submenu__item-title">{{ dashboard.Title }}</div>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
<div class="wk-navbar__actions">
    @if (!authService.hasSecurityLevel("summary_view_new_ui_enabled") || cardViewService.currentViewType !== "all") {
        @if (isJobsBillingDashboard) {
            <wk-jobs-filter-menu />
        } @else {
            <wk-filter-menu />
        }
        @if (cardViewService?.currentViewType !== "all") {
            <wk-sort-menu />
        }

        <wk-display />
    }

    <button-field-pds3 type="icon">
        <button class="wk-navbar__action fa fa-question" title="{{ 'Navbar.Help' | translate }}" (click)="openHelp()"></button>
    </button-field-pds3>
    <div class="collapse navbar-collapse"></div>
</div>
